import {
  Divider,
  Paper,
  Stack,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

import React from "react";

import { useTranslation } from "react-i18next";

import * as Yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FormProvider, RHFTextField } from "../hook-form";

import { responsiveValue } from "../../theme/Styles/responsiveValue";

import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserContact,
  setSnackbarSeverity,
} from "../../Containers/OnBoarding/slice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
} from "../../Containers/AdminView/adminSlice";
import { getUserEntity } from "../../redux/features/authSlice";
import { useSnackbar } from "notistack";
import Modal from "../Modal";
import ConfirmDialog from "../ConfirmDialog";
import { deleteContact } from "../../Containers/OnBoarding/slice";
const UserContactFrom = ({
  setEditContacts,
  editContacts,
  contact,
  setOpen,
  t,
  }) => {
  const {
    auth: {
      profile: { entity },
    },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [confirmationDialog2, setConfirmationDialog2] = React.useState(false);
  const [modalOpen2, setModalOpen2] = React.useState(false);
  const [modelContent2, setModelContent2] = React.useState("");


  const contactSchema = Yup.object().shape({
    name: Yup.string().required("Name é de preenchimento obrigatório"),
    email: Yup.string()
      .email()
      .required(`${t("email")} é de preenchimento obrigatório`),
      mobile: Yup.string()
      .required(`O campo ${t("mobile")} é de preenchimento obrigatório`)
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
      .length(9, "O campo contato telefónico tem que ter 9 dígitos"),
    designation: Yup.string().required(`${t("designation")} é de preenchimento obrigatório `),
  });
  const setModalOpenValue2 = (val) => {
    setModalOpen2(val);
  };
  const defaultValues = {
    name: editContacts ? contact.name : "",
    email: editContacts ? contact.email : "",
    mobile: editContacts ? contact.mobile : "",
    designation: editContacts ? contact.designation : "",
  };

  const methods = useForm({
    resolver: yupResolver(contactSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const { name, email, mobile, designation } = data;
    const payload = {
      name: name,
      email: email,
      designation: designation,
      telephone: "string",
      mobile: mobile,
    };
    if (!editContacts) {
      payload["id"] = 0;
      payload["entityId"] = entity.entityId;
      payload["isPrimaryContact"] = false;
      payload["isOfficialRepresentative"] = true;
      payload["updatedBy"] = entity.entityId;
    } else {
      payload["id"] = contact.id;
      payload["contactId"] = contact.contactId;
      payload["entityId"] = contact.entityId;
      payload["isPrimaryContact"] = contact.isPrimaryContact;
      payload["isOfficialRepresentative"] = contact.isOfficialRepresentative;
      payload["updatedBy"] = contact.entityId;
    }
    await dispatch(addUserContact(payload))
      .unwrap()
      .then((res) => {
        dispatch(getUserEntity(entity.entityId));
        enqueueSnackbar({
          message: !editContacts
            ? t("addContactSuccessfully")
            : t("contactDetailSuccessfullyUpdated"),
          
          variant: "success",
        });

        if (!editContacts) {
          setOpen(false);
        } else {
          setEditContacts(false);
        }
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("someThingWentWrong"),
          
          variant: "error",
        });
      });
  };
  const onDeleteHandle = (e) => {
    setConfirmationDialog2(true); 
  }

  const onConfirm2 = () => {
    if (contact.contactId) {
      dispatch(deleteContact(contact.contactId))
        .unwrap()
        .then((res) => {
          dispatch(getUserEntity(entity.entityId));
          setConfirmationDialog2(false); 
          enqueueSnackbar({
            message: "Contato removido com sucesso",
            variant: "success",
          });
        })
        .catch((error) => {
          enqueueSnackbar({
            message: t("someThingWentWrong"),
            variant: "error",
          });
        });
    }
  };

  return (
    <>
      <>
        <Grid
          container
          spacing={responsiveValue("", "", "", "2", "2", "0")}
          direction={responsiveValue(
            "",
            "",
            "",
            "row",
            "row",
            "column-reverse"
          )}
          justifyContent={"space-evenly"}
        >
          <Grid item>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ maxHeight: "400px", overflow: "auto" }}>
                <Box>
                  <Stack spacing={3}>
                    <Paper>
                      {/* <Typography>
                        {editContacts
                          ? `${t("edit")} ${t("contacts")}`
                          : t("contacts")}
                      </Typography> */}
                      <RHFTextField
                        id="outlined-basic"
                        label={t("contactName")}
                        variant="outlined"
                        name="name"
                        // type='number'
                        sx={{ marginTop: "20px" }}
                        fullWidth
                      />
                      <RHFTextField
                        id="outlined-basic"
                        label={t("mobile")}
                        variant="outlined"
                        name="mobile"
                        sx={{ marginTop: "20px" }}
                        fullWidth
                        inputProps={{ maxLength: 9 }}
                      />
                      <RHFTextField
                        id="outlined-basic"
                        label={t("emailAddress")}
                        variant="outlined"
                        name="email"
                        sx={{ marginTop: "20px" }}
                        fullWidth
                      />
                      <RHFTextField
                        id="outlined-basic"
                        label={t("designation")}
                        variant="outlined"
                        name="designation"
                        sx={{ marginTop: "20px" }}
                        fullWidth
                      />
                    </Paper>
                  </Stack>
                </Box>
              </Box>
              <Stack direction={"row"} justifyContent={"space-between"} marginTop={2}>
              <Box>
              <Button
                  onClick={() => {
                    editContacts ? setEditContacts(false) : setOpen(false);
                  }}
                  sx={{
                    background: "#FFEEEE",
                    color: "#FF0000",
                    padding: '8px 22px',
                    borderRadius: '4px',
                    "&:hover": { background: "#FF0000", color: "#FFEEEE" },
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  sx={{ ml: 1 ,borderRadius:'4px'}}
                  // loading={loading}
                  onClick={onDeleteHandle}
                
                >
                  {t("delete")}
                </Button>
              </Box>
                
                <LoadingButton sx={{
            borderRadius:'4px'
          }} size="large" type="submit" variant="contained">
                  {t("toSave")}
                </LoadingButton>
              </Stack>
            </FormProvider>
          </Grid>
        </Grid>
      </>
      <Modal
        open={modalOpen2}
        onClose={() => setModalOpenValue2(false)}
        title={t("")}
        content={modelContent2}
      />
      <ConfirmDialog
        open={confirmationDialog2}
        handleClose={() => setConfirmationDialog2(false)}
        title={t("")}
        content={"Tem a certeza que quer apagar este contacto ?"}
        onConfirm={onConfirm2}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </>
  );
};

export default UserContactFrom;
